import {
  Grid,
  Box,
  Button,
  TablePagination,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Card,
  CardContent,
  Alert,
  Skeleton
} from '@material-ui/core';

import React, { useState, useEffect, useRef } from 'react';
import { RackDetails } from './RackDetails';
import { Underline } from 'react-feather';


export const RacklistData = (props) => {

  console.log("RacklistData  ", props)

  if (props.rackRows !== Underline) {
    return (
      <>
        {props.rawdata.map((item, index) => (
          <TableRow
            hover
            key={index}
          >
            <TableCell>
              <h2>{item.rackRowName}</h2>
            </TableCell>
            <TableCell>
              <RackDetails circuitConsumptions={item.circuitConsumptions} />
            </TableCell>
          </TableRow>
        ))}



      </>
    )
  } else {
    return (
      <></>
    )
  }

}
